import React, { useEffect } from "react";

const ToastMessage = ({ message, type = "success", onClose, onConfirm, onCancel }) => {
  useEffect(() => {
    if (type === "confirm") return; // neodpočítávej automaticky
    const timer = setTimeout(onClose, 1200);
    return () => clearTimeout(timer);
  }, [onClose, type]);

  const bgColor = {
    success: "bg-green-500",
    error: "bg-red-500",
    confirm: "bg-yellow-500",
    info: "bg-gray-800"
  }[type];

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 pointer-events-none">
      <div className={`text-white px-6 py-4 rounded shadow-lg text-lg pointer-events-auto ${bgColor} max-w-xl w-full text-center`}>
        <p className="mb-2">{message}</p>
        {type === "confirm" && (
          <div className="flex justify-center gap-4 mt-2">
            <button
              className="bg-white text-black px-4 py-1 rounded hover:bg-gray-200"
              onClick={onConfirm}
            >
              Ano
            </button>
            <button
              className="bg-white text-black px-4 py-1 rounded hover:bg-gray-200"
              onClick={onCancel}
            >
              Ne
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ToastMessage;